import createHistory from 'history/createBrowserHistory';
export default createHistory();



//////////////////
// WEBPACK FOOTER
// ./src/history.ts
// module id = 185
// module chunks = 81